import { forwardRef, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Container — enforces max-w-7xl with px-4 md:px-8.
 * Use inside <Section> (or directly inside any <section>) to guarantee
 * consistent horizontal alignment across the marketing site.
 */
export const Container = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      data-layout-container="standard"
      className={cn("mx-auto w-full max-w-7xl px-4 md:px-8", className)}
      {...props}
    />
  ),
);
Container.displayName = "Container";

/**
 * Section — a <section> wrapping a <Container>. Children are rendered
 * inside the constrained container automatically. Pass `as="section"` styles
 * via `className` and inner-container styles via `containerClassName`.
 */
type SectionProps = HTMLAttributes<HTMLElement> & {
  containerClassName?: string;
};

export const Section = forwardRef<HTMLElement, SectionProps>(
  ({ className, containerClassName, children, ...props }, ref) => (
    <section ref={ref} data-layout-section="standard" className={className} {...props}>
      <Container className={containerClassName}>{children}</Container>
    </section>
  ),
);
Section.displayName = "Section";
